import React, { Component } from "react";
import { NavHashLink } from "react-router-hash-link";

//Logo
import Logo from "../../assets/logo-w.png";

//Icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { faCopyright } from "@fortawesome/free-regular-svg-icons";

//Social Icons
import { socialIcons } from "../../assets/socialIcons";

export default class footer extends Component {
  render() {
    return (
      <footer>
        <div className="data">
          <div className="Info">
            <img
              className="logo"
              src={Logo}
              alt="ENVIROZONE L.L.C"
              title="ENVIROZONE L.L.C"
            />
            <h3>IG Agent</h3>
            <p>
              Built for real estate agencies of all sizes, Bring home more deals
              with the all-in-one real estate CRM platform that's crafted for
              your business.
            </p>
          </div>
          <div className="Links">
            <h2>Links</h2>
            <hr />
            <NavHashLink
              activeClassName="selected"
              className="link"
              to="#Intro"
              smooth
            >
              Home
            </NavHashLink>
            <NavHashLink
              activeClassName="selected"
              className="link"
              to="/#About"
              smooth
            >
              About Us
            </NavHashLink>
            <NavHashLink
              activeClassName="selected"
              className="link"
              to="/#Services"
              smooth
            >
              Services
            </NavHashLink>
            {/* <NavHashLink
              activeClassName="selected"
              className="link"
              to="/#Pricing"
              smooth
            >
              Pricing
            </NavHashLink> */}
            <NavHashLink
              activeClassName="selected"
              className="link"
              to="/#Benefits-&-Improvements"
              smooth
            >
              Benefits & Improvements
            </NavHashLink>
            {/* <NavHashLink
              activeClassName="selected"
              className="link"
              to="/#Contact"
              smooth
            >
              Contact
            </NavHashLink> */}
          </div>
          <div className="Contacts" id="Contact">
            <h2>Get in Touch!</h2>
            <hr />
            <div className="social">
              <h3>Social:</h3>
              {socialIcons.map((icons, index) => {
                return (
                  <a
                    key={icons.iconName + index}
                    href={icons.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon className="icon" icon={icons.iconName} />
                  </a>
                );
              })}
            </div>
            <div>
              <h3>Contacts:</h3>
              <p>
                <a href="tel:+923360001606">
                  <FontAwesomeIcon icon={faPhone} /> +92-336-0001606{" "}
                </a>
                <span> / </span>
                <a href="tel:+923400169999">
                  <FontAwesomeIcon icon={faPhone} /> +92-340-0169999{" "}
                </a>
              </p>
              <p>
                <a href="mailto:daniyalmalikc@gmail.com">
                  <FontAwesomeIcon icon={faEnvelope} /> info@igagent.com.pk
                </a>
              </p>
              <p>
                <FontAwesomeIcon className="location" icon={faMapMarkerAlt} />{" "}
                House No L-279, Second Floor, Sector 35/A, Korangi No# 4, Zaman
                Town.
              </p>
            </div>
          </div>
        </div>
        <div className="designer">
          <p>
            IG Agent is powered by IG Estate and Marketing.{" "}
            <FontAwesomeIcon icon={faCopyright} /> {new Date().getFullYear()} IG
            Agent All rights reserved. Designed & Developed by{" "}
            <a href="https://appxamine.com">Appxamine</a>
            {/* <a href="https://mdaniyalmalikc.web.app"> M. Daniyal Malik .C</a> */}
          </p>
        </div>
      </footer>
    );
  }
}
